import React from 'react';
import LlamaMimiPage from './LlamaMimiPage';
import './styles.css'; // CSSを必ず読み込む

function App() {
  return <LlamaMimiPage />;
}

export default App;
